import * as actionTypes from '../actions/Actions';

export const initialState = {
  data: {
    businessInfo: {
      company: '',
      legal: '',
      brand: '',
      idType: '',
      nameType: null,
      image: null,
      registered: false,
    },
    companyInfo: {
      idBrand: '',
      idCountry: '',
      idState: '',
      idIndustry: '',
      idCity: '',
      phone: '',
      email: '',
      zipCode: '',
      address: '',
      nameCountry: null,
      nameState: null,
      nameIndustry: null,
      nameCity: null
    },
    bankAccount: {
      accountId: ''
    },
    companyRep: {
      fullName: '',
      email: '',
      phone: '',
      address: ''
    },
    image: {
      image: null
    },
    final: {
      step: 0,
      message: '',
      type: ''
    }



  },
};

// ==============================|| Otp REDUCER ||============================== //

const signUpReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.NEXT_STEP_1:
      return {
        ...state,
        data: {
          ...state.data,
          businessInfo: {
            company: action.company,
            legal: action.legal,
            brand: action.brand,
            idType: action.idType,
            nameType: action.nameType,
            image: action.image,
            registered: action.registered
          }
        }
      };
    case actionTypes.NEXT_STEP_2:
      return {
        ...state,
        data: {
          ...state.data,
          companyInfo: {
            idBrand: action.idBrand,
            idCountry: action.idCountry,
            idState: action.idState,
            idIndustry: action.idIndustry,
            idCity: action.idCity,
            phone: action.phone,
            email: action.email,
            zipCode: action.zipCode,
            address: action.address,
            nameCountry: action.nameCountry,
            nameState: action.nameState,
            nameIndustry: action.nameIndustry,
            nameCity: action.nameCity
          }
        }
      };

    case actionTypes.NEXT_STEP_3:
      return {
        ...state,
        data: {
          ...state.data,
          bankAccount: {
            accountId: action.accountId
          }
        }
      };
    case actionTypes.NEXT_STEP_4:
      return {
        ...state,
        data: {
          ...state.data,
          companyRep: {
            fullName: action.fullName,
            phone: action.phone,
            email: action.email,
            address: action.address
          }
        }
      };

    case actionTypes.SIGN_UP_SUCCESS:
      return {
        ...state,
        data: {
          businessInfo: {
            company: '',
            legal: '',
            brand: '',
            idType: '',
            nameType: null,
            image: null,
            registered: false,
          },
          companyInfo: {
            idBrand: '',
            idCountry: '',
            idState: '',
            idIndustry: '',
            idCity: '',
            phone: '',
            email: '',
            zipCode: '',
            address: '',
            nameCountry: null,
            nameState: null,
            nameIndustry: null,
            nameCity: null
          },
          bankAccount: {
            accountId: ''
          },
          companyRep: {
            fullName: '',
            email: '',
            phone: '',
            address: ''
          },
          image: {
            image: null
          },
          final: {
            step: 0,
            message: '',
            type: ''
          }
        },
      };
    case actionTypes.DROP_IMAGE:
      return {
        ...state,
        data: {
          ...state.data,
          image: {
            image: action.image
          }
        }
      };


    case actionTypes.FINAL_STEP:
      return {
        ...state,
        data: {
          ...state.data,
          final: {
            step: action.step,
            message: action.message,
            type: action.typeMessage
          }
        }
      };
    default:
      return state;
  }
};

export default signUpReducer;
